export const ENTITLEMENT_FIELD_ORDER = [
  "projects",
  "tenants",
  "machines",
  "targets",
  "deploymentTargets",
  "users",
  "taskCap",
  "spaces",
  "nodes",
  "storageLimitGb",
  "retentionDays",
  "telemetryEnforced",
  "serviceNow",
  "jiraServiceManagement",
  "spaceLevelInsights",
  "auditLogFeeds",
  "priorityTask",
  "globalDeploymentFreeze",
  "processTemplates",
  "policies",
  "projectTemplates",
  "restrictedPermissions",
  "usageDeclarationExpiryDays",
  "excessAllowedWithUsageDeclaration",
] as const;
